import { AST } from '@handlebars/parser';
import { NodeType } from '../../../node/types';

export const isNullLiteral = (expression: AST.Node): expression is AST.NullLiteral =>
  expression.type === NodeType.NullLiteral;
